import { configureStore } from "@reduxjs/toolkit";
import {
  awsReducer,
  languageReducer,
  loaderReducer,
  notificationReducer,
  profileReducer,
} from "../Reducer/Reducer";

export const store = configureStore({
  reducer: { languageReducer, profileReducer, loaderReducer, notificationReducer, awsReducer },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
